import {FC} from 'react'
import {AdminRoom} from '../../../core/_models'

type Props = {
  room: AdminRoom
}

const ColorCell: FC<Props> = ({room}) => (
  <div className='d-flex align-items-center'>
    <span className='w-25px h-25px rounded' style={{backgroundColor: room.color}} title={room.color} />
  </div>
)

export {ColorCell}
